import React, { Component } from "react";
import PropTypes from "prop-types";
import throttle from "LIB/throttle";
import moment from "moment";
import { SearchPropTypes } from "MODULES/shared/components";

export default class MonthSelect extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    ...SearchPropTypes
  };

  constructor(props) {
    super(props);
    this.onChange = throttle(props.onSubmit, 300);
  }

  updateDate = e => {
    const date =
      e.target.value &&
      moment(e.target.value)
        .startOf("month")
        .format("YYYY-MM-DD");

    this.onChange(date);
  };

  render() {
    const { initialDate } = this.props;
    const initialDateFormatted =
      initialDate && moment(initialDate).format("YYYY-MM");
    return (
      <span
        className="input-group-btn"
        style={{ backgroundColor: "#4f4f4f", paddingRight: "5px" }}
      >
        <input
          style={{
            fontWeight: "normal",
            fontSize: "13px",
            paddingLeft: "15px",
            paddingRight: "10px",
            textTransform: "uppercase",
            backgroundColor: "#4f4f4f",
            height: "34px",
            boxShadow: "none"
          }}
          type="month"
          name="month_filter"
          className="form-control"
          placeholder="Month/Year"
          defaultValue={initialDateFormatted}
          onChange={this.updateDate}
        />
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/MonthSelect/MonthSelect.jsx